export const TWITTER_URL = "https://x.com/rationalmurtaza";
export const LINKEDIN_URL = "https://www.linkedin.com/in/techmurtaza/";
export const GITHUB_URL = "https://github.com/techmurtaza";
export const INSTAGRAM_URL = "https://www.instagram.com/rationalmurtaza";
export const FACEBOOK_URL = "https://www.facebook.com/rationalmurtaza/";